import { parsePayload, throwCommError, OperationError } from "../DAO";
import { User } from "./User";

export async function whoami(): Promise<User> {
   return fetch('../admin/auth/whoami', {
      'method': 'POST',
      'headers': {
         'Accept': 'application/json'
      }
   }).catch(throwCommError).then(parseUserResponse);
}

export async function login(username: string, password: string): Promise<User> {
   const authedUser = await whoami().catch((err: OperationError) => {
      // if fail because not authenticated, try to authenticate.
      if (err.issues.some(i => i.code === 'UNAUTHORIZED')) {
         return sendAuthRequest(username, password);
      }
      throw err; // Otherwise rethrow to be handled dow the chain.
   });
   // In case we had already been authenticated, make sure we are who we expect to be.
   if (authedUser?.username?.toLowerCase() !== username.toLowerCase()) {
      await logout();
      return sendAuthRequest(username, password);
   }
   return authedUser;
}

async function sendAuthRequest(username: string, password: string): Promise<User> {
   const formData = new URLSearchParams();
   formData.append('username', username);
   formData.append('password', password);

   return fetch('../admin/auth/login', {
      'method': 'POST',
      'headers': {
         'Content-Type': 'application/x-www-form-urlencoded',
         'Accept': 'application/json'
      },
      'body': formData
   }).catch(throwCommError).then(parseUserResponse);
}

export async function logout(): Promise<void> {
   return fetch('../admin/auth/logout', {
      'method': 'POST'
   }).catch(throwCommError) //
      .then(parsePayload) //
      .then(payload => {
         if (!payload.success) {
            throw OperationError.from(payload);
         }
      });
}

async function parseUserResponse(response: Response): Promise<User> {
   const payload = await parsePayload(response);
   if (payload.success) {
      return User.parse(payload.value);
   }
   throw OperationError.from(payload);
}